module.exports = __webpack_public_path__ + "img/709.cbef2540.jpg";